import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/core/services/v2/common.service";
import {
  CreditCardPaymentInformation,
  HealthSystemPaymentInformationv2,
} from "src/app/physician/models/healthSystemPaymentInformation";
import { PhysicianService } from "src/app/physician/physician.service";
import { SideBarComponentInterface } from "src/app/shared/components/dynamic-right-sidebar/sideBarComponentInterface";
import { SideBarInitializeParameters } from "src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";

@Component({
  selector: "app-setup-CreditCard-form",
  templateUrl: "./setup-CreditCard-form.component.html",
  styleUrls: ["./setup-CreditCard-form.component.scss"],
})
export class SetupCreditCardFormComponent
  implements OnInit, SideBarComponentInterface
{
  @Output() closeCardChange = new EventEmitter();
  errorMessage: string;

  cardType: string = "Visa";
  cardNumber: string;
  cardYear: number;
  cardMonth: string;
  cardCode: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  zip: string;
  address: string;
  accepted: boolean = false;
  currentYear = new Date().getFullYear();

  years = Array(20)
    .fill(0)
    .map((x, i) => {
      return {
        label: i + this.currentYear,
        value: i + this.currentYear,
      };
    });
  months = [
    {
      value: "01",
      label: "Jan",
    },
    {
      value: "02",
      label: "Feb",
    },
    {
      value: "03",
      label: "Mar",
    },
    {
      value: "04",
      label: "Apr",
    },
    {
      value: "05",
      label: "May",
    },
    {
      value: "06",
      label: "Jun",
    },
    {
      value: "07",
      label: "Jul",
    },
    {
      value: "08",
      label: "Aug",
    },
    {
      value: "09",
      label: "Sep",
    },
    {
      value: "10",
      label: "Oct",
    },
    {
      value: "11",
      label: "Nov",
    },
    {
      value: "12",
      label: "Dec",
    },
  ];

  totalcost: any;

  constructor(
    private physicianService: PhysicianService,
    private router: Router,
    private commonService: CommonService,
    private windowsLoader: WindowLoaderService
  ) {}

  title: string = "Credit Card";

  setData(data: any) {}

  ngOnInit() {}

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  updatePaymentInfo() {
    const info = <CreditCardPaymentInformation>{
      cardNumber: this.cardNumber,
      cardType: this.cardType,
      cardExpirationMMYY: `${this.cardYear}-${this.cardMonth}`,
      cardCode: this.cardCode,
      firstName: this.firstName,
      lastName: this.lastName,
      address: this.address,
      city: this.city,
      state: this.state,
      zip: this.zip,
      AuthorizeNetUserID : ""
      // email
    };

    this.windowsLoader.show();
    this.physicianService.updatePaymentInformation(info).subscribe(
      (result) => {
        this.windowsLoader.hide();
        if (result.resultStatus.isSuccess) {
          this.closeCardChange.emit();
          this.errorMessage = "";
        } else {
          this.errorMessage = result.resultStatus.message;
        }
      },
      (error) => {
        console.error(error);
        this.windowsLoader.hide();
      }
    );
  }
}
